export var SettingsParamType;
(function (SettingsParamType) {
    SettingsParamType["Number"] = "Number";
    SettingsParamType["Boolean"] = "Boolean";
    SettingsParamType["String"] = "String";
    SettingsParamType["Text"] = "Text";
    SettingsParamType["Object"] = "Object";
})(SettingsParamType || (SettingsParamType = {}));
//# sourceMappingURL=SettingsContext.types.js.map